export function isComposableProduct(product) {
  return product.category !== 'boissons' && product.category !== 'packs';
}

export function createCartItemFromProduct(product, quantity = 1) {
  return {
    productId: product.id,
    name: product.name,
    image: product.image,
    quantity,
    unitPrice: product.basePrice,
    lineTotal: product.basePrice * quantity,
    selectedIncluded: product.includedIngredients || [],
    removedIncluded: [],
    selectedExtras: [],
    selectedDrinks: [],
    notes: '',
  };
}
